import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién estoy empezando con Registros Akáshicos?',
    a: 'Sí. De hecho, cuanto antes incorpores un método profesional, más rápido vas a desarrollar seguridad y claridad en tus sesiones. No necesitás años de experiencia para aplicar estas herramientas.'
  }, {
    q: '¿Y si ya tengo experiencia leyendo registros?',
    a: 'También. Muchos terapeutas experimentados utilizan estos materiales para ordenar su práctica, profundizar sus intervenciones y trabajar con más estructura.'
  }, {
    q: '¿Necesito tener un consultorio para aprovechar El Altar del Terapeuta Akáshico?',
    a: 'No. Las herramientas de posicionamiento, WhatsApp, contenido y comunicación pueden aplicarse incluso si recién estás comenzando a ofrecer sesiones.'
  }, {
    q: '¿Voy a tener que exponerme o convertirme en influencer?',
    a: 'No. El objetivo no es que te conviertas en creador de contenido. El objetivo es que aprendas a comunicar tu trabajo con claridad para que las personas correctas puedan encontrarte.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Vas a recibir acceso inmediato luego de completar tu compra. Podrás descargar todos los materiales en formato PDF y acceder desde computadora, celular o tablet.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para revisar el material. Si sentís que no es para vos, simplemente nos escribís y te devolvemos el dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-74">
      <div className="text-center mb-12" data-id="element-75">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-purpleDark" data-id="element-76">
          <span className="mr-3" data-id="element-77">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-78">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-purple/25 bg-white/80" data-id="element-79">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-80">
              <span className="font-medium pr-8 text-brand-purpleDark text-[14px] md:text-base lg:text-lg" data-id="element-81">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-82" />
            </button>
            <AnimatePresence data-id="element-83">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-84">
                  <div className="px-6 pb-5 text-brand-text border-t border-brand-purple/20 pt-4 bg-white/60 text-[13px] md:text-base leading-relaxed" data-id="element-85">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};